export const LOGO_WORDMARK = "https://customer-assets.emergentagent.com/job_9e7b6413-4b5b-49a9-9627-207a6d9bc1ae/artifacts/3h242hko_Asset%204%404x.png";
export const LOGO_MARK = "https://customer-assets.emergentagent.com/job_9e7b6413-4b5b-49a9-9627-207a6d9bc1ae/artifacts/v4lqoeue_Asset%203%404x.png";

// WhatsApp enquiry
export const WHATSAPP_NUMBER = "919517717917";
export const WHATSAPP_URL = "https://wa.me/919517717917?text=Hi%20ProMill%2C%20I%27d%20like%20to%20enquire%20about%20your%20products.";

// User-provided transparent PNG hero (food cluster on transparent BG)
export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_nourish-promill/artifacts/qq6o2n01_e6963bd5-c320-4bf9-9433-1879e7e5818a.png";
export const LIFESTYLE_IMAGE = "https://images.unsplash.com/photo-1490645935967-10de6ba17061?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

// Pillar card food images (user-supplied for brand-consistent visuals)
export const PILLAR_IMAGES = {
    wrap: "https://customer-assets.emergentagent.com/job_nourish-promill/artifacts/zk743kdt_Millet%20wraps.png",
    bowl: "https://customer-assets.emergentagent.com/job_nourish-promill/artifacts/5xyhg328_Protein%20Bowls.png",
    sauce: "https://customer-assets.emergentagent.com/job_nourish-promill/artifacts/rf9qzv5z_clean%20sauces.png",
    addons: "https://customer-assets.emergentagent.com/job_nourish-promill/artifacts/nz366bfi_Fresh%20Add-ons.png",
};

export const PRODUCTS = [
    {
        id: "p1",
        name: "Pro-Millet Power Bowl",
        category: "Bowls",
        tagline: "Ragi base • Grilled paneer • Tahini drizzle",
        price: 349,
        protein: 32,
        kcal: 480,
        diet: ["veg", "high-protein"],
        badges: ["Bestseller", "High Protein"],
        image: "https://images.unsplash.com/photo-1547592180-85f173990554?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p2",
        name: "Smoked Tofu Millet Wrap",
        category: "Wraps",
        tagline: "Jowar wrap • Smoked tofu • Coriander chutney",
        price: 249,
        protein: 24,
        kcal: 410,
        diet: ["vegan"],
        badges: ["Vegan", "Clean"],
        image: "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p3",
        name: "Mean Green Smoothie",
        category: "Smoothies",
        tagline: "Spinach • Whey isolate • Bajra milk",
        price: 199,
        protein: 28,
        kcal: 290,
        diet: ["veg", "high-protein"],
        badges: ["Pre-Workout"],
        image: "https://images.unsplash.com/photo-1610970881699-44a5587cabec?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p4",
        name: "Grilled Paneer Salad",
        category: "Salads",
        tagline: "Foxtail millet • Tandoori paneer • Mint yogurt",
        price: 299,
        protein: 30,
        kcal: 440,
        diet: ["veg", "high-protein", "keto"],
        badges: ["High Protein", "Keto"],
        image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p5",
        name: "Spicy Chickpea Buddha",
        category: "Bowls",
        tagline: "Kodo millet • Chickpea masala • Beet hummus",
        price: 329,
        protein: 26,
        kcal: 510,
        diet: ["vegan", "high-fiber"],
        badges: ["High Fiber", "Vegan"],
        image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p6",
        name: "Berry Recovery Shake",
        category: "Smoothies",
        tagline: "Wild berries • Casein • Ragi crisps",
        price: 229,
        protein: 25,
        kcal: 320,
        diet: ["veg"],
        badges: ["Post-Workout"],
        image: "https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p7",
        name: "Peri Peri Chicken Wrap",
        category: "Wraps",
        tagline: "Bajra wrap • Peri peri chicken • Yogurt slaw",
        price: 319,
        protein: 31,
        kcal: 470,
        diet: ["non-veg", "high-protein"],
        badges: ["High Protein"],
        image: "https://images.unsplash.com/photo-1626700051175-6818013e1d4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p8",
        name: "Chipotle Chicken Bowl",
        category: "Bowls",
        tagline: "Quinoa-millet mix • Smoky chicken • Avocado",
        price: 379,
        protein: 35,
        kcal: 530,
        diet: ["non-veg", "high-protein"],
        badges: ["Bestseller"],
        image: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p9",
        name: "Rajma Power Salad",
        category: "Salads",
        tagline: "Foxtail millet • Rajma • Lime-tahini dressing",
        price: 269,
        protein: 22,
        kcal: 380,
        diet: ["vegan", "high-fiber"],
        badges: ["Vegan"],
        image: "https://images.unsplash.com/photo-1505253758473-96b7015fcd40?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
    {
        id: "p10",
        name: "Mocha Protein Smoothie",
        category: "Smoothies",
        tagline: "Cold brew • Whey • Cacao nibs",
        price: 219,
        protein: 27,
        kcal: 310,
        diet: ["veg", "high-protein"],
        badges: ["Pre-Workout"],
        image: "https://images.unsplash.com/photo-1572490122747-3968b75cc699?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    },
];

export const VALUE_PILLARS = [
    {
        kicker: "01",
        title: "Millet Wraps",
        desc: "Soft, wholesome, satisfying — stone-milled from jowar, bajra & ragi.",
        icon: "wrap",
    },
    {
        kicker: "02",
        title: "Protein Bowls",
        desc: "Balanced, hearty, delicious — 30g+ clean protein per bowl.",
        icon: "bowl",
    },
    {
        kicker: "03",
        title: "Clean Sauces",
        desc: "Crafted in-house with zero refined sugar or seed oils.",
        icon: "sauce",
    },
    {
        kicker: "04",
        title: "Fresh Add-ons",
        desc: "Crisp veggies and superfood toppings, picked daily.",
        icon: "leaf",
    },
];

export const STEPS = [
    { n: "01", title: "Choose Your Base", desc: "Foxtail, ragi, jowar or kodo — pick your favorite ancient grain." },
    { n: "02", title: "Add Your Protein", desc: "Paneer, tofu, grilled chicken or rajma. Stack up to 35g of protein." },
    { n: "03", title: "Drizzle Clean Sauce", desc: "From peri-peri to tahini-mint — every sauce is sugar & seed-oil free." },
    { n: "04", title: "Top It Off", desc: "Pickled veg, micro-greens, roasted seeds. Make it yours." },
];

export const TESTIMONIALS = [
    {
        name: "Aisha K.",
        role: "Marathoner • Bengaluru",
        quote: "Finally, fast food that doesn't wreck my training week. The ragi bowl is my pre-long-run ritual.",
    },
    {
        name: "Rohan M.",
        role: "Product Designer • Mumbai",
        quote: "Tastes like my grandmother cooked it, hits like a protein shake. ProMill nailed the Indian palate.",
    },
    {
        name: "Tanvi S.",
        role: "Yoga Coach • Delhi",
        quote: "Clean ingredients I can pronounce. Zero seed oils. My clients keep asking where I order from.",
    },
];

export const NUTRITION_STATS = [
    { value: "30g+", label: "Protein per bowl" },
    { value: "500", label: "Kcal capped" },
    { value: "100%", label: "Indian millets" },
    { value: "0", label: "Refined sugar" },
];

// Build Your Meal options
export const BUILD_BASES = [
    { id: "b1", name: "Foxtail Millet", protein: 8, kcal: 180, price: 0, desc: "Light, nutty, gluten-free" },
    { id: "b2", name: "Ragi (Finger Millet)", protein: 7, kcal: 170, price: 0, desc: "Iron-rich, earthy flavor" },
    { id: "b3", name: "Jowar (Sorghum)", protein: 9, kcal: 190, price: 20, desc: "Classic, fluffy texture" },
    { id: "b4", name: "Kodo Millet", protein: 8, kcal: 175, price: 30, desc: "High fiber, low GI" },
    { id: "b5", name: "Quinoa-Millet Mix", protein: 11, kcal: 210, price: 50, desc: "Complete proteins blend" },
];

export const BUILD_PROTEINS = [
    { id: "pr1", name: "Grilled Paneer", protein: 22, kcal: 220, price: 80, type: "veg" },
    { id: "pr2", name: "Smoked Tofu", protein: 18, kcal: 180, price: 70, type: "vegan" },
    { id: "pr3", name: "Tandoori Chicken", protein: 28, kcal: 240, price: 110, type: "non-veg" },
    { id: "pr4", name: "Rajma Masala", protein: 15, kcal: 190, price: 50, type: "vegan" },
    { id: "pr5", name: "Chickpea Falafel", protein: 16, kcal: 210, price: 60, type: "vegan" },
];

export const BUILD_SAUCES = [
    { id: "s1", name: "Mint Tahini", price: 0, heat: 0 },
    { id: "s2", name: "Peri Peri", price: 20, heat: 3 },
    { id: "s3", name: "Coriander Chutney", price: 0, heat: 1 },
    { id: "s4", name: "Smoked Tomato", price: 20, heat: 2 },
    { id: "s5", name: "Cilantro Lime Yogurt", price: 20, heat: 0 },
];

export const BUILD_TOPPINGS = [
    { id: "t1", name: "Pickled Onions", price: 0 },
    { id: "t2", name: "Micro Greens", price: 30 },
    { id: "t3", name: "Roasted Pumpkin Seeds", price: 30 },
    { id: "t4", name: "Beet Hummus", price: 40 },
    { id: "t5", name: "Avocado Slices", price: 60 },
    { id: "t6", name: "Crispy Chickpeas", price: 30 },
];

export const STORES = [
    {
        id: "st1",
        name: "ProMill Indiranagar",
        address: "100 Feet Rd, HAL 2nd Stage, Indiranagar, Bengaluru, KA 560038",
        phone: "+91 80 4567 8901",
        hours: "Mon–Sun · 8:00 AM – 11:00 PM",
        lat: 12.9784,
        lng: 77.6408,
        city: "Bengaluru",
    },
    {
        id: "st2",
        name: "ProMill Koramangala",
        address: "5th Block, 80 Feet Rd, Koramangala, Bengaluru, KA 560095",
        phone: "+91 80 4567 8902",
        hours: "Mon–Sun · 9:00 AM – 11:30 PM",
        lat: 12.9352,
        lng: 77.6245,
        city: "Bengaluru",
    },
    {
        id: "st3",
        name: "ProMill BKC",
        address: "Bandra Kurla Complex, G-Block, Bandra East, Mumbai, MH 400051",
        phone: "+91 22 4567 8903",
        hours: "Mon–Sun · 8:30 AM – 11:00 PM",
        lat: 19.0658,
        lng: 72.8682,
        city: "Mumbai",
    },
    {
        id: "st4",
        name: "ProMill Powai",
        address: "Hiranandani Gardens, Powai, Mumbai, MH 400076",
        phone: "+91 22 4567 8904",
        hours: "Mon–Sun · 9:00 AM – 10:30 PM",
        lat: 19.1197,
        lng: 72.9051,
        city: "Mumbai",
    },
    {
        id: "st5",
        name: "ProMill Cyber Hub",
        address: "DLF Cyber City, Phase 2, Gurugram, HR 122002",
        phone: "+91 124 456 7895",
        hours: "Mon–Sun · 8:00 AM – 11:00 PM",
        lat: 28.4949,
        lng: 77.0890,
        city: "Delhi NCR",
    },
    {
        id: "st6",
        name: "ProMill Connaught Place",
        address: "Block A, Connaught Place, New Delhi, DL 110001",
        phone: "+91 11 4567 8906",
        hours: "Mon–Sun · 9:00 AM – 11:00 PM",
        lat: 28.6315,
        lng: 77.2167,
        city: "Delhi NCR",
    },
];
